import styled from "styled-components";
import { AiFillMinusCircle } from "react-icons/ai";
import { FiMinusCircle } from "react-icons/fi";
import { BsPlusCircleFill, BsPlusCircle } from "react-icons/bs";

export const RemoveButton = styled(FiMinusCircle)`
  color: #757371;
  font-size: 1.5rem;

  @media (max-width: 640px) {
    font-size: 1.1rem;
  }
`;

export const RemoveButtonHover = styled(AiFillMinusCircle)`
  color: #3948ff;
  font-size: 1.5rem;

  @media (max-width: 640px) {
    font-size: 1.1rem;
  }
`;

export const AddAsset = styled(BsPlusCircleFill)`
  color: #3948ff;
  font-size: 2.2rem;

  @media (max-width: 640px) {
    font-size: 1.4rem;
  }
`;

export const AddAssetHover = styled(BsPlusCircle)`
  color: #3948ff;
  font-size: 2.2rem;

  @media (max-width: 640px) {
    font-size: 1.4rem;
  }
`;

export const Card = styled.div`
  height: 100%;

  &:hover {
    background-color: ${(props) => props.bg};
  }

  @media (max-width: 640px) {
    width: 95%;
  }
`;

export const ModalButtons = styled.button`
  border-radius: 6px;
  border: 1px solid;
  border-color: ${(props) => (props.bg ? props.bg : "#787878")};
  height: 45px;
  width: 175px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.bg && props.bg};
  color: ${(props) => (props.bg ? "white" : "#787878")};

  &:focus {
    outline: none;
  }
`;
